/**
 * Vuetify is required for the buy-vignette flow (SelectVignette date picker).
 * Hero shopping cart loads Vuetify lazily when the calendar opens.
 */
export function pageNeedsVuetify() {
    if (typeof document === 'undefined') return false;
    return Boolean(document.querySelector('buy-vignette'));
}
